var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"button-load-file"},[_c('input',{attrs:{"type":"file","accept":"image/*","multiple":""},on:{"change":_vm.onChange}}),_vm._t("default",[_vm._v("Upload")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }